import React, { useCallback, useState, useMemo } from 'react';
import { useTranslation } from 'localization/useTranslation';
import { Modal, ModalVariant } from '@patternfly/react-core';
import SimpleTable, { RowSelection } from 'components/Common/SimpleTable/SimpleTable';
import { confirmButtons } from 'components/Modals/ModalButtons';
import styles from './DefaultContactModal.module.css';
import _ from 'lodash';
import useBoolean from 'utils/hooks/useBoolean';


const EditDefaultContactModal = ({ title, tableColumns, isOpen, onClose, available, selected: selectedIn, onSelected }) => {
  const T = useTranslation();
  const [_selected, setSelected] = useState(null);
  const selected = _selected ?? selectedIn;

  const _onClose = useCallback(() => {
    setSelected(null);
    onClose();
  }, [onClose]);

  const onConfirm = useCallback(() => {
    onSelected(selected);
    setSelected(null);
    onClose();
  }, [onSelected, selected, onClose]);

  return (
    <Modal
      variant={ModalVariant.medium}
      className={styles.selectionModal}
      title={title}
      isOpen={isOpen}
      onClose={_onClose}
      actions={confirmButtons({ T, onConfirm: onConfirm, onCancel: _onClose })}
    >
      <SimpleTable
        data={available}
        columns={tableColumns}
        rowSelection={RowSelection.MULTI_CHECKBOX}
        selectedRows={selected}
        onSelectedRows={setSelected}
        compact
        usePaging
      />
    </Modal>
  );
};


const ViewDefaultContactModal = ({ title, tableColumns, isOpen, onClose, available, selected: selectedIn, onSelected }) => {
  const T = useTranslation();
  const [_selected, setSelected] = useState(null);
  const selected = _selected ?? selectedIn;
  const [isAddModalOpen, , hideAddModal, toggleAddModal] = useBoolean(false);

  const _onClose = useCallback(() => {
    setSelected(null);
    onClose();
  }, [onClose]);

  const onConfirm = useCallback(() => {
    onSelected(selected);
    setSelected(null);
    onClose();
  }, [onSelected, selected, onClose]);

  const globalActions = useMemo(() => {
    return [
      {
        label: 'Add',
        onClick: () => {
          toggleAddModal();
        }
      }
    ];
  }, [toggleAddModal]);

  const _onSelected = useCallback((selected) => {
    setSelected(oldSelected => {
      return _.unionBy(oldSelected, selected, 'id');
    });
    onSelected(selected);
    hideAddModal();
  }
  , [onSelected, hideAddModal]);

  const notSelected = useMemo(() => {
    return _.differenceBy(available, selected, 'id');
  }, [available, selected]);

  return (
    <>
      <Modal
        variant={ModalVariant.medium}
        className={styles.selectionModal}
        title={title}
        isOpen={isOpen}
        onClose={_onClose}
        actions={confirmButtons({ T, onConfirm: onConfirm, onCancel: _onClose })}
      >
        <SimpleTable
          globalActions={globalActions}
          data={selected}
          columns={tableColumns}
          rowSelection={RowSelection.MULTI_CHECKBOX}
          selectedRows={selected}
          onSelectedRows={setSelected}
          compact
          usePaging
        />
      </Modal>
      <EditDefaultContactModal
        title="Add Default Contact"
        tableColumns={tableColumns}
        isOpen={isAddModalOpen}
        onClose={hideAddModal}
        available={notSelected}
        selected={selected}
        onSelected={_onSelected}
      />
    </>
  );
};

export default ViewDefaultContactModal;
